import type { CollabUgcRecipientTerms } from '@fluenceur/types';
import { useMemo } from 'react';
import { useInvitationData } from '@/contexts/invitation-context';
import { useCollabUgcTermsQuery } from '@/hooks/queries/use-collab-ugc-terms-query';
import { useCollabRecipients } from './use-collab-recipients';

const NONE: ReadonlyMap<string, CollabUgcRecipientTerms> = new Map();

/**
 * The UGC terms of the wizard's recipients, by identity, as the server reads
 * them for the send: the same answer whichever entry opened the wizard
 * (contact sheet, applications, brief editor, proposed creators). Asked on the
 * UGC path only; a recipient without an identity is absent and grants two.
 */
export const useUgcRecipientTerms = (): ReadonlyMap<string, CollabUgcRecipientTerms> => {
  const { collabType } = useInvitationData();
  const recipients = useCollabRecipients();
  const ids = recipients.flatMap((recipient) =>
    recipient.creatorIdentityId ? [recipient.creatorIdentityId] : []
  );
  const { data } = useCollabUgcTermsQuery(ids, collabType === 'ugc');

  return useMemo(
    () => (data ? new Map(data.map((terms) => [terms.creatorIdentityId, terms])) : NONE),
    [data]
  );
};
